import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { OpenNewWindow16 } from 'ui/icons/action/OpenNewWindow16';
import { FormField } from 'ui/formField/FormField';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { BasicSelectField } from 'lib/iterable-hook-form';
import { SelectOptionsContainer } from 'ui/selects/Selects.styles';
import { getApiKeys } from '../selectors';
import { generateTypeOptions } from '../utils';
import { KEY_TYPE } from './ApiKeyModal.constants';
import { SpacedWebLink } from './ApiKeyModal.styled';

const SELECT_WIDTH = 360;

const TypeSelect = styled(BasicSelectField)`
  margin-right: ${spacing.plusHalf};
  width: ${pxToRem(SELECT_WIDTH)};
`;

const StyledSelectOptionsContainer = styled(SelectOptionsContainer)`
  width: ${pxToRem(SELECT_WIDTH)};
`;

export const KeyTypeField = () => {
  const { keyTypes = [] } = useSelector(getApiKeys);

  const typeOptions = generateTypeOptions(keyTypes);

  return (
    <FormField inputId={KEY_TYPE} labelText="Type">
      <TypeSelect
        name={KEY_TYPE}
        options={typeOptions}
        SelectOptionsContainer={StyledSelectOptionsContainer}
      />
      <SpacedWebLink href="https://support.iterable.com/hc/en-us/articles/360043464871-API-Keys-">
        <span>Learn more about key types</span>
        <OpenNewWindow16 isColorInherited={true} />
      </SpacedWebLink>
    </FormField>
  );
};
